import axios from '../utils/axios';

export default function fetchProductTypes(adminId) {
    
    return (
        axios.get('/admin/' + adminId + '/manageSeekerSubscriptions/v2/admin/plans')
    )
}
